export const DASHBOARD_ACCESS_PERMISSIONS = {
  ALERTS: 'access_alerts_dash',
  ADMIN_USERS: 'access_admin_users',
  BOARD_BUILDER: 'access_board_builder',
  CORRELATIONS: 'view_correlations_table',
  LEAGUES: 'access_leagues_dash',
  MEMBERS: 'access_memberdash',
  MEMBER_GROUPS: 'access_member_groups',
  MISSIONS: 'access_missions_dash',
  PAYMENTS: 'access_payments_dash',
  PLAYER_PACKS: `access_player_packs_dash`,
  PLAYERS: 'access_players_dash',
  POLLS: 'access_polls_hq',
  PROMOTIONS: 'access_promotions_dash',
  PROMOTION_APPROVALS: 'access_promotion_approvals',
  RESOLUTIONS: 'access_resolution_dash',
  ROLES: 'access_roles_hq',
  RULESETS: 'access_rulesets_hq',
  SCORING: 'access_scoring_dash',
  SIMULATIONS: 'access_simulations',
  STAT_TYPE: 'access_stat_type_dash',
  ALLOWED_STATES: 'access_allowed_states_dash',
  STREAK: 'access_streak_hq',
  TEAMS: 'access_teams_dash',
  TRADING: 'access_trading_dash',
  GAME_TYPES: 'access_game_types_dash',
  GAME_MODE: 'access_game_modes_dash',
  UNSETTLEMENTS: 'view_unsettlement_actions'
};

export const EDIT_CORRELATIONS_PERMISSION = 'edit_correlations_table';
export const EDIT_GAME_MODES_PERMISSION = 'edit_game_modes';
export const CREATE_OR_EDIT_PLAYERS_PERMISSION = 'create_or_edit_players';
export const CREATE_OR_EDIT_STAT_TYPES_PERMISSION = 'create_or_edit_stat_types';
export const CREATE_OR_EDIT_GAME_TYPES_PERMISSION = 'create_or_edit_game_types';

export const CREATE_OR_EDIT_POLLS_PERMISSION = 'create_or_edit_polls';
export const CREATE_OR_EDIT_TEAMS_PERMISSION = 'create_or_edit_teams';

export const MEMBER_PROFILE_VIEW_PERMISSIONS = {
  MEMBER_VIEW_PROFILE_MAP: 'pii_view_location_data',
  MEMBER_PROFILE_VIEW_IP_INFO: 'pii_view_technical_identifiers'
};

export const MEMBER_TAB_VIEW_PERMISSIONS = {
  MEMBER_VIEW_ENTRIES: 'memberdash_view_entries_tab',
  MEMBER_VIEW_NOTES: 'memberdash_view_notes',
  MEMBER_VIEW_PAYMENTS: 'memberdash_view_payments_tabs',
  MEMBER_VIEW_POLLS: 'memberdash_view_polls_tab',
  MEMBER_VIEW_PROMOTIONS: 'memberdash_view_promotions_tab',
  MEMBER_VIEW_REFERRALS: 'memberdash_view_referrals_tab',
  MEMBER_VIEW_RG: 'memberdash_view_rg_tab',
  MEMBER_VIEW_TRANSACTIONS: 'memberdash_view_transactions_tab'
};

export const MEMBER_ACTIONS_PERMISSIONS = {
  MEMBER_ACTIONS_MENU: 'memberdash_actions_menu',
  MEMBER_CHANGE_LOG: 'memberdash_change_log',
  MEMBER_CREATE_ADJUSTMENT: 'memberdash_adjustment',
  MEMBER_DEACTIVATE_USER: 'deactivate_user',
  MEMBER_EDIT_ACCOUNT_INFORMATION: 'edit_user_information',
  MEMBER_ENROLL_KINDBRIDGE: 'memberdash_kindbridge_enroll',
  MEMBER_MANAGE_GROUPS: 'manage_member_groups',
  MEMBER_MANAGE_TIN_COLLECTION: 'memberdash_tin_collection',
  MEMBER_MANAGE_VIP_STATUS: 'memberdash_manage_vip',
  MEMBER_MANUALLY_PASS_USER: 'memberdash_manually_pass_user',
  MEMBER_REFUND_ENTRY: 'refund_entry',
  MEMBER_RESET_PASSWORD: 'memberdash_password_reset',
  MEMBER_CREATE_ADJUSTMENT_TRANSACTION_MAX: 'create_adjustment',
  MEMBER_VIEW_RULESET: 'configure_member_ruleset'
};

export const MEMBER_GROUP_PERMISSIONS = {
  MEMBER_GROUPS_VIEW: 'user_groups_view',
  MEMBER_GROUPS_EDIT: 'user_groups_edit',
  MEMBER_GROUPS_CREATE: 'user_groups_create',
  MEMBER_GROUPS_VIEW_MEMBERS: 'user_groups_view_members',
  MEMBER_GROUPS_MANAGE_MEMBERS: 'user_groups_manage_members',
  MEMBER_GROUPS_CSV_UPLOAD: 'user_groups_csv_upload',
  MEMBER_GROUPS_VIEW_RULESET: 'user_groups_configure_member_ruleset'
};

export const PROMOTIONS_PERMISSIONS = {
  PROMOTIONS_CREATE: 'create_promotions',
  PROMOTIONS_VIEW: 'view_promotions'
};

export const MISSION_PERMISSIONS = {
  MISSION_CREATE: 'reward_challenge_create',
  MISSION_VIEW: 'reward_challenge_view'
};

export const RESOLUTION_PERMISSIONS = {
  RESOLUTION_CREATE: 'create_resolution'
};

export const UNSETTLEMENTS_PERMISSIONS = {
  UNSETTLEMENTS_CREATE: 'create_unsettlement_actions',
  UNSETTLEMENTS_WIN_PROTECTION: 'create_win_protection'
};
